import * as ActionCable from "~/vendor/actioncable";

const cable = ActionCable.createConsumer();

if (process.env.NODE_ENV === "development") {
  ActionCable.logger.enabled = true;
}

// Set data-cable-connected attribute when cable connects/disconnects
const originalRecordConnect = cable.connection.monitor.recordConnect;
const originalRecordDisconnect = cable.connection.monitor.recordDisconnect;

cable.connection.monitor.recordConnect = function () {
  document.body.setAttribute("data-cable-connected", "true");
  return originalRecordConnect.call(this);
};

cable.connection.monitor.recordDisconnect = function () {
  document.body.removeAttribute("data-cable-connected");
  return originalRecordDisconnect.call(this);
};

// TODO: add a react context which can propagate the consumer instead of using
// this global module, once we know every usage of the consumer is within a
// react tree capable of using a context. Ideally switch to use-action-cable
// hooks eventually.

export default cable;
